<template>
<div class="page-header full-width">
    <!-- to handle multiple lines title, mock invisible wrapper -->
    <div class="page-header-not-fixed-invisible-wrapper base-wrapper">
        <div class="page-header-left-side">
            <breadcrumbs :links=links></breadcrumbs>
            <div class="page-header-title-container">
                <heading :level="'h2'" class="page-header-title-value">
                    {{ title }}
                </heading>
            </div>
        </div>
        <slot></slot>
    </div>
    <!-- the real div that is shown to user -->
    <div class="page-header-fixed-wrapper base-wrapper">
        <div class="page-header-left-side">
            <breadcrumbs :links=links></breadcrumbs>
            <div class="page-header-title-container">
                <heading :level="'h2'" class="page-header-title-value">
                    {{ title }}
                </heading>
            </div>
        </div>
        <slot></slot>
    </div>
</div>
</template>

<script>
import Breadcrumbs from '../../shared/breadcrumbs.vue';
import Heading from '~/components/shared/heading.vue';

export default {
    name: 'page-header',
    components: { Breadcrumbs, Heading },
    props: {
        title: {
            type: String,
        },
        links: {
            type: Array,
        },
    },
};

</script>

<style lang="scss">

.page-header {
    margin-bottom: 1rem;
    min-height: 6rem;

    @media (min-width: 992px) {
        margin-bottom: 0;
    }

    &-left-side {
        display: flex;
        flex-direction: column;
        flex-basis: 50%;
    }

    .base-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 1.5rem 1.5rem 1.2rem 1.5rem;
    }

    &-not-fixed-invisible-wrapper {
        visibility: hidden;
    }

    &-fixed-wrapper {
        background-color: $color-neutral-light-100;
        position: fixed;
        top: 80px; /* fixed navbar height */
        z-index: 1;
        box-shadow: 0px 0.23rem 0.23rem rgba(0, 0, 0, 0.1);
    }

    &-title {

        &-container {
            width: 100%;
        }

        &-value {
            color: $color-neutral-dark-400;
        }
    }

    .breadcrumbs-link {
        &.paragraph {
            margin-bottom: 0.5rem;
        }
    }

}

#scans {
    .page-header {
        .page-header-title-value.heading {
            font-size: 1.25rem !important;
        }

        .page-header-fixed-wrapper.base-wrapper,
        .page-header-not-fixed-invisible-wrapper.base-wrapper {
            padding: 1.1rem 1.5rem !important;
        }

        .paragraph.button-medium {
            font-size: .83rem !important;
            margin-bottom: .3rem;
        }
    }
}

</style>
